/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { getClientList, getLocations } from 'store/clientSlice';
import { search_type } from 'utils';
import { Box } from 'atoms';
import { VendorContractForm } from 'components/forms';
import { getVehicalList } from 'store/vehicleSlice';

export default function CreateClientContractPage() {
	const [formData, setFormData] = useState({});
	const { cities = [], statesWithCites } = useSelector((state) => state.clientState);
	console.log('statesWithCites', statesWithCites);
	const [vendorsData, setvendorssdata] = useState('');
	const [vehicleData, setVehicledata] = useState('');
	const dispatch = useDispatch();
	const { id } = useParams();
	useEffect(() => {
		dispatch(
			getClientList({
				search_type: 'vendor',
				filter_by: {
					vendor_type: 'regular',
				},
			})
		)
			.then((res) => {
				const data = res?.data?.map((item) => ({
					value: item?.id,
					label: item?.vendor_info?.vendor_name,
					item,
				}));
				setvendorssdata(data);
			})
			.finally(() => {});
		dispatch(
			getLocations({
				search_type: search_type?.location,
				filter_by: {},
			})
		);
	}, [dispatch]);

	useEffect(() => {
		dispatch(
			getVehicalList({
				search_type: 'vehicle',
				filter_by: {},
			})
		)
			.then((res) => {
				console.log(res);
				const data = res?.rows?.map((item) => ({
					value: item?.vehicle_type,
					label: item?.vehicle_type,

					item,
				}));
				setVehicledata(data);
			})
			.finally(() => {});
	}, [dispatch]);

	useEffect(() => {
		if (id) {
			dispatch(
				getClientList({
					search_type: 'vendor_contract',
					filter_by: {
						id,
					},
				})
			).then((res) => {
				console.log('res', res);
				setFormData(res?.data?.[0]);
			});
		}
	}, [dispatch, id]);

	if (id && isEmpty(formData)) {
		return <p>Loading....</p>;
	}
	return (
		<Box>
			<VendorContractForm
				isEditMode={Boolean(formData?.id)}
				formData={formData}
				vendorsData={vendorsData}
				cites={cities}
				vehicleData={vehicleData}
			/>
		</Box>
	);
}
